import {Box, Hide, Icon, useDevice} from 'platform/foundation';
import {cn, cva} from 'platform/shared';

import {RequiredTestIdProps, suffixTestId} from 'shared/web';

import {SLOT_HEIGHT} from '../constants/slotHeight';
import {useIsDragging} from '../hooks/useIsDragging';

interface ContentCellProps extends RequiredTestIdProps {
  isClickDisabled: boolean;
  onCellClick: (event: React.MouseEvent) => void;
}

const contentCellVariants = cva(
  'flex h-full w-full items-center justify-center opacity-0 [will-change:opacity,background-color,cursor]',
  {
    variants: {
      isDisabled: {
        true: 'cursor-default',
        false: 'cursor-pointer hover:bg-[var(--color-palettes-neutral-20-100)] hover:opacity-100',
      },
    },
  }
);

export function ContentCell(props: ContentCellProps) {
  const device = useDevice();
  const isDragging = useIsDragging();

  const isDisabled = isDragging || props.isClickDisabled || device === 'mobile';

  return (
    <Box
      height={SLOT_HEIGHT}
      borderBottom="1px solid"
      borderLeft="1px solid"
      borderColor="general.separator"
    >
      <div
        className={cn(contentCellVariants({isDisabled}))}
        onClick={!isDisabled ? props.onCellClick : undefined}
        data-testid={suffixTestId('contentCell', props)}
      >
        <Hide when={isDisabled}>
          <Icon
            data-testid={suffixTestId('contentCell-icon', props)}
            value="lightbox/plus"
            size={4}
            color="text.tertiary"
          />
        </Hide>
      </div>
    </Box>
  );
}
